import React from 'react';
import imageManifest from './imageManifest';
import ImageTable from './ImageTable';
import './events.css';

const Events = () => {
  const images = [
    imageManifest['reunion21.jpg'],
    imageManifest['reunion22.jpg'],
    imageManifest['reunion222.jpg'],
    imageManifest['reunion23.jpg'],
    imageManifest['reunion232.jpg']
  ];

  const anniversary30 = [
    imageManifest['fatimaNcake.jpeg'],
    imageManifest['grp1.jpeg'],
    imageManifest['grp2.jpeg'],
    imageManifest['fummiNcake.jpeg'],
    imageManifest['srboiNgirl.jpeg'],
    imageManifest['fAbeNcake.jpeg'],
    imageManifest['all.jpeg'],
    imageManifest['sam.jpeg'],
    imageManifest['ribboncuttin.jpeg'],
    imageManifest['beforeribboncut.jpeg'],
    imageManifest['seyi-report.jpeg'],
    imageManifest['friendsNcake.jpeg'],
    imageManifest['banner.jpeg'],
    imageManifest['folajuNcake.jpeg']
  ];

  return (
    <div className="events-columns">
      <div className="events-column">
        <h5 className='title'>Reunion Party</h5>
        <ImageTable images={images} />
      </div>
      <div className="events-column">
        <h5 className='title'>30th Anniversary</h5>
        <ImageTable images={anniversary30} />
      </div>
    </div>
  );
};

export default Events;
